import type { ReactNode } from "react";
import { useI18n } from "../i18n";

export function StudentShell({ children, title }: { children: ReactNode; title?: string }) {
  const { t, toggle } = useI18n();
  return <main className="student-page">
    <section className="student-phone">
      <div className="student-toolbar"><button className="language-button" onClick={toggle}>{t("switch")}</button></div>
      <header className="student-brand">
        <img src="/logo.png" alt="Assemble Studio" />
        <h1>{title ?? t("checkin")}</h1>
        <p>{t("subtitle")}</p>
      </header>
      {children}
    </section>
  </main>;
}
export function AdminShell({ children, title }: { children: ReactNode; title: string }) {
  const { t, toggle } = useI18n();
  return <>
    <header className="topbar"><div className="topbar-inner">
      <a href="/admin" className="brand-link"><img src="/logo.png" alt="Assemble Studio" /><div><strong>{title}</strong><span>Assemble Studio</span></div></a>
      <button className="language-button" onClick={toggle}>{t("switch")}</button>
    </div></header>
    <main className="app-main">{children}</main>
  </>;
}
export function Notice({ kind = "info", children }: { kind?: "info" | "error" | "success"; children: ReactNode }) {
  return <div className={"notice " + kind} role={kind === "error" ? "alert" : "status"} aria-live="polite">{children}</div>;
}